import KeenSlider from "keen-slider";

const slickOpts = {
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: true,
  dots: false,
  responsive: [
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        arrows: false,
        dots: true,
      },
    },
  ],
};

export default {
  init() {
    this.closeAlinari();
    this.initAlinari();
    this.initGallery();
    this.initLoginBlock();
    this.initUploadController();

    this.formState = false;

    //SX SLICK
    //DX KEEN
    //window.addEventListener('load', () => this.fixSlickWidth());
    this.fixSlickWidth();
    window.addEventListener("resize", () => this.fixSlickWidth());

    //$(window).on('resize', this.fixSlickWidth());
    /*
    $(document).on("submit","#wpmem_register_form", (e) => {
      let form = $(e.currentTarget);
      console.log('submit!');
      if (!this.formState) {
        e.preventDefault();
        let front = $("#docfront_img").attr("src");
        let retro = $("#docretro_img").attr("src");
        console.log('return false!');

        if (typeof retro != "undefined" && retro.length > 0 && typeof front != "undefined" && front.length > 0) {
          this.formState = true;
          console.log("son qui!", this.formState);
          //$(this).find(".buttons").click();
          form.submit();
          return false;
        } else {
          $(".doc_errors").show();
          console.log("oioi!");
        }

        return false;
      }
      console.log('continuoooo!');
    });*/

    $(document).on("submit", "#wpmem_register_form", (e) => {
      let front = $("#docfront_img").attr("src");
      let retro = $("#docretro_img").attr("src");

      if (!(typeof retro != "undefined" && retro.length > 0 && typeof front != "undefined" && front.length > 0)) {
        e.preventDefault();

        if (typeof retro == "undefined" || retro.length == 0) {
          $("#tab-2").prepend("<p class=\"text-danger\">Caricare fronte documento</p>");
        }
        if (typeof front == "undefined" || front.length == 0) {
          $("#tab-2").prepend("<p class=\"text-danger\">Caricare retro documento</p>");
        }
        $(".tab-content").scrollTop(0);

        $(".img_error").show();
        return false;
      }
    });

    $(".pc-control-img > a").on("click", function (e) {
      e.preventDefault();
      return false;
    });

    $(document).on("click", ".lightbox-vote", function (e) {
      e.preventDefault();
      location.href = $(this).attr("href");
      return false;
    });

    $(document).on("click", ".lightbox-share", function (e) {
      e.preventDefault();
      location.href = $(this).attr("href");
      return false;
    });

    if (window.changeText) {
      $('.upload-label label[for="photo-description"]').text(window.changeText);
    }

    $(document).on("click", ".open-info", function (e) {
      e.preventDefault();
      $(this).parent().toggleClass('open');
      if ($(this).parent().hasClass('open')) {
        $(this).parent().find(".pre").hide();
        $(this).parent().find(".full").slideDown();
      } else {
        $(this).parent().find(".full").slideUp({
          complete: function () { $(this).parent().find(".pre").fadeIn(); }
        });
      }
      return false;
    });

    $(document).on("click", ".open-rules", function(e){
      e.preventDefault();
      $(this).closest(".content").addClass("rules");
      return false;
    });

    $(document).on("click", ".close-rules", function (e) {
      e.preventDefault();
      $(this).closest(".content").removeClass("rules");
      return false;
    });

    $("#tos").next('a').attr("onClick", false);

    $("#tos").next('a').off("click");

    $("#tos").next('a').on("click", function(e) {
      e.preventDefault();
      e.stopPropagation();
      $(this).closest(".content-switcher").addClass("tos");
      return false;
    });

    $(".close-tos").on("click", function (e) {
      e.preventDefault();
      e.stopPropagation();
      $(this).closest(".content-switcher").removeClass("tos");
      return false;
    })


  },
  finalize() {},

  slickOpts : {},

  closeAlinari () {
    $(document).on("click", ".slick-lightbox", function (e) {
      e.preventDefault();
      let is_close_alinari =
        $(e.target).closest('.slick-lightbox-slick-item-inner').length > 0 ||
        $(e.target).closest('.slick-arrow').length > 0;
      if (!is_close_alinari) $(".slick-lightbox-close").trigger("click");
    });

    $(document).on('click', '.closeAlinari', function (e) {
      console.log($(e.target));
      e.stopPropagation();
      e.preventDefault();
      $(this).parent().hide();
      return false;
    });
  },

  fixSlickWidth() {
    console.log(this.slickOpts);
    if($(window).width() > 767){
      setTimeout(function () {
        const $sourceImg = $(".containerSlider.keen-slider .slide .img-wrap").find("img");
        if (typeof $sourceImg !== "undefined" && typeof $sourceImg[0] !== "undefined") {
          const width = $sourceImg[0].getBoundingClientRect().width - 3.5;
          $(".first-col").find(".slick-initialized.slick-slider").css({ "width": width, "opacity": 1 });
          $(".btnPartecipa").css({ "width": width, "opacity": 1 });
          $(".slider").slick("unslick").slick(slickOpts);
        } else $(".btnPartecipa").css({ "opacity": 1 });
      }, 300);
    } else {
      setTimeout(function () {
        const width = 'auto';
        $(".first-col").find(".slick-initialized.slick-slider").css({ "width": width, "opacity": 1 });
        $(".btnPartecipa").css({ "width": width, "opacity": 1 });
        $(".slider").slick("unslick").slick(slickOpts);
      }, 300);
    }
  },

  initUploadController() {
    if (window.selectedCategory) {
      $("#photo-category").val(window.selectedCategory);
    }
  },

  initLoginBlock() {
    $(".nav-link").on("click", function () {
      if ($(this).hasClass("dx"))
        $(this).parent().parent().parent().addClass("registration");
      else $(this).parent().parent().parent().removeClass("registration");
    });

    $(".modal-backdrop").on("click", function () {
      $(this).parent().fadeOut();
    });

    $(".modal-close").on("click", function (e) {
      e.preventDefault();
      $(this).parent().parent().fadeOut();
      return false;
    });
  },

  initGallery() {
    for (var i = 0; i < $(".containerSlider").length; i++) {
      const slider = new KeenSlider("#containerSlider-" + i, {
        loop: true,
        mode: "snap",
        breakpoints: {
          "(max-width: 767px)": {
            slides: {
              perView: 1.3,
              spacing: 10,
            },
          },
          "(min-width: 768px) and (max-width: 991px)": {
            slides: {
              perView: 1.5,
              spacing: 10,
            },
          },
          "(min-width: 992px) and (max-width: 1199px)": {
            slides: {
              perView: 2.1,
              spacing: 20,
            },
          },
          "(min-width: 1200px) and (max-width: 1399px)": {
            slides: {
              perView: 2.8,
              spacing: 20,
            },
          },
          "(min-width: 1400px) and (max-width: 1600px)": {
            slides: {
              perView: 2.8,
              spacing: 30,
            },
          },
        },
        slides: {
          perView: 3,
          spacing: 30,
        },
      });

      $("#containerSlider-" + i)
        .next()
        .find(".block-1-slider-next")
        .on("click", function (e) {
          e.preventDefault();
          slider.next();
          return false;
        });

      $("#containerSlider-" + i)
        .next()
        .find(".block-1-slider-prev")
        .on("click", function (e) {
          e.preventDefault();
          slider.prev();
          return false;
        });
    }

    $(".containerSlider").slickLightbox({
      itemSelector: ".open-lightbox",
      closeOnBackdropClick: false,
      caption: function (element, info) {
        return $(element).data("caption");
      },
    });
  },

  initAlinari() {

    const alinariSlider = $(".slider").slick(slickOpts);

    $("body").on("click", ".open-alinari-desc", function (e) {
      e.preventDefault();
      $(this).parent().toggleClass("open");
      return false;
    });
  },
};

function closeDiv() {
  var suggerimentoContest = document.querySelector('.suggerimentoContest');
  suggerimentoContest.style.display = "none";
}

document.getElementById("closeDiv").addEventListener("click", closeDiv);


// Find the selected code
const selectedCode = document.querySelector('#new-post');

// Check if the code is found
if (selectedCode) {
  // Add the HTML code
  const htmlCode = '<div class="txtTrick">Ti invitiamo a caricare una foto che si avvicini il più possibile, per luogo e visuale, alle immagini-guida del passato del territorio che hai scelto.</div>';
  selectedCode.insertAdjacentHTML('beforebegin', htmlCode);
}
